// Main containers for menu/submenu
const pageNavigation = document.querySelector('.page-navigation')
const itemsWithUndermenu = pageNavigation?.querySelectorAll('.has-undermenu') || []
const submenuContainer = document.querySelector('.submenu-container')
const submenuLeftSide = submenuContainer?.querySelector('.submenu-left-side')
const submenuRightSide = submenuContainer?.querySelector('.submenu-right-side')

/**
 * Highlights the active item in the left-side menu based on the `data-parent-menu-id` attribute
 * of the `ul` element in the right-side menu.
 */
const activeLeftSideItem = () => {
    const ulElement = submenuRightSide.querySelector('ul')

    // Check if 'ulElement' exists and has a 'data-parent-menu-id' attribute
    if (ulElement && ulElement.dataset && ulElement.dataset.parentMenuId) {
        const dataMenu = ulElement.dataset.parentMenuId

        // Remove the 'submenu-active' class from all active menu items
        submenuLeftSide.querySelectorAll('ul > li > a.submenu-active')
            .forEach(item => item.classList.remove('submenu-active'))

        // Find the target item and add the 'submenu-active' class to its previous sibling
        const targetItem = submenuLeftSide.querySelector(`[data-parent-menu-id="${dataMenu}"]`)

        // Check if the target item and its previous sibling exist
        if (targetItem && targetItem.previousSibling) {
            targetItem.previousSibling.classList.add('submenu-active')
        }
    }
}

/**
 * Function to check and clone an element into a target container.
 * Ensures that the target container does not already contain the same element before cloning.
 * @param {HTMLElement} targetContainer - The container where the source element will be cloned.
 * @param {HTMLElement} sourceElement - The element to be cloned.
 */
const cloneElementIfNotExists = (targetContainer, sourceElement) => {
    // Check if the source element is already cloned into the target container
    const alreadyCloned = Array.from(targetContainer.children).some(child =>
        child.isEqualNode(sourceElement),
    )

    if (!alreadyCloned) {
        // If not already cloned, clear the target container and clone the source element
        targetContainer.innerHTML = ''
        targetContainer.appendChild(sourceElement.cloneNode(true))
    } else {
        // If the element already exists, clear the target container to close the menu
        targetContainer.innerHTML = ''
    }

    // Activate the appropriate item on the left side
    activeLeftSideItem()
}

/**
 * Controls the left-side submenu.
 * Handles cloning of elements into the left-side container and manages submenu interactions.
 * @param {HTMLElement} undermenu - The submenu element to control and display.
 */
const controlLeftSide = (undermenu) => {
    // Clone the submenu into the container on the left side if it doesn't already exist
    cloneElementIfNotExists(submenuLeftSide, undermenu)

    // If the submenu is ready and active, close the left and right sides
    const sebmenuIsReady = submenuLeftSide.querySelector('.submenu-active')

    if (sebmenuIsReady) {
        submenuLeftSide.innerHTML = '' // Close the left-side submenu
        submenuRightSide.innerHTML = '' // Close the right-side submenu
        return
    }

    // Automatically open the submenu item if the parent page is open
    const activeItemWithUndermenu = submenuLeftSide.querySelector('.active_link')?.nextElementSibling
    if (activeItemWithUndermenu) {
        cloneElementIfNotExists(submenuRightSide, activeItemWithUndermenu)
        return
    }

    const firstItemWithUndermenu = submenuLeftSide.querySelector('.has-undermenu')?.nextElementSibling
    // Automatically open the first submenu item if available
    if (firstItemWithUndermenu) {
        cloneElementIfNotExists(submenuRightSide, firstItemWithUndermenu)
    } else {
        submenuRightSide.innerHTML = ''
    }
}

/**
 * Initializes the navigation logic.
 * Attaches click listeners to elements with submenus and manages submenu interactions.
 */
const initNavigation = () => {
    if (!pageNavigation || !submenuContainer || !submenuLeftSide || !submenuRightSide) {
        return
    }

    submenuLeftSide.innerHTML = ''  // Clear the left-side menu at initialization

    // Add click event listeners to all items with an undermenu
    for (const item of itemsWithUndermenu) {
        item.addEventListener('click', function(e) {
            e.preventDefault()
            controlLeftSide(e.target.nextElementSibling)
        })
    }

    // Handle clicks on the left-side submenu for items with further undermenus
    submenuLeftSide.addEventListener('click', function(e) {
        if (e.target.classList.contains('has-undermenu') || e.target.classList.contains('active_link')) {
            e.preventDefault()
            const nextElement = e.target.nextElementSibling

            // Check if the next element is already cloned into the right-side container
            const alreadyCloned = [...submenuRightSide.children].some(child =>
                child.isEqualNode(nextElement),
            )

            if (!alreadyCloned) {
                cloneElementIfNotExists(submenuRightSide, nextElement)
            }

            // Add a class to display the right-side submenu on smaller screens
            if (window.innerWidth < 991) {
                submenuContainer.classList.add('show-right-submenuContainer')
            }
        }
    })
}

export { initNavigation }
